// extracted by mini-css-extract-plugin
module.exports = {"ChallengeModePage":"ChallengeModePage_ChallengeModePage__qaHF4"};